import { filter, find, memoize } from 'lodash';

import modelData from '../configs/model-data-config';

// Filters models data down to those with object properties matching criteria
export const matchCriteria = (criteria, generatorCollection = modelData) =>
  filter(generatorCollection, criteria);

// Finds the first match of the provided array of models
export const findGeneratorMatch = (generatorCollection, requiredKw) =>
  find(generatorCollection, gen => gen.KW >= requiredKw);

/**
 * Provides the recommended model and two others, with KW value lower and higher respectively
 * @param {object} criteria - An object with props matching those in model data
 * @param {number} requiredWatts - Watts required, converted to KW when comparing to data
 * @param {array=} generatorCollection - Collection of all possible models
 * @return {{lower: ({}|undefined), recommended: ({}|undefined), higher: ({}|undefined)}}
 */
export const getRecommendation = memoize((criteria, requiredWatts, generatorCollection) => {
  const kW = requiredWatts / 1000;
  const getMatch = c => findGeneratorMatch(matchCriteria(c, generatorCollection), kW);
  const recommended = getMatch({ ...criteria, isQuiet: true });
  const budget = getMatch({ ...criteria, isQuiet: false });
  return {
    recommended,
    // Only include a budget option if it has suitable power & is less expensive (or price is N/A)
    ...(budget && (recommended.basePrice === 0 ||
        (recommended.basePrice >= budget.basePrice)) && { budget }),
  };
  // Creates unique key for each recommendation query
}, (criteria, watts) => JSON.stringify([criteria, watts]));

export default getRecommendation;



// WEBPACK FOOTER //
// ./src/views/Home/components/helpers/recommendations.js